<div class="selector-page">
  <div class="selector-card">
    <div class="logo-container">
      <!-- Vericure wordmark, UF-Cobalt recolour (#3C75BB — the brand accent).
         Interim raster: an exact-alpha recolour of the original 605x77 wordmark,
         to be replaced by a vector if one is supplied. The lightened
         vericure-logo-cobalt-text.png (#6391C9) is checked in beside it for
         surfaces where full Cobalt reads dim. -->
      <img src="assets/vericure-logo-cobalt.png" alt="Vericure" class="logo" />
    </div>

    <h2>{{ 'CustomerSelectorSelectCustomer' | t }}</h2>
    <p class="subtitle">{{ 'CustomerSelectorChooseTheCustomerAccountYouWant' | t }}</p>

    <div class="loading" *ngIf="isLoading">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <span>{{ 'AdminLoadingCustomers' | t }}</span>
    </div>

    <!-- Every company on offer belongs to a tenant other than the one signed in
         with. An ordinary user will be refused whatever they pick, so say it here
         rather than let them find out as an authorization error later. -->

    <div class="tenant-mismatch" *ngIf="noTenantMatch">
      None of your companies belong to the organisation you signed in with.
      Choose one only if you know you have access to it — otherwise sign in with a
      different account, or contact Vericure Support at
      {{ supportEmail }} or {{ supportPhone }}.
    </div>


    <div class="error-message" *ngIf="errorMessage">
      <i class="fa-solid fa-triangle-exclamation"></i>
      {{ errorMessage }}
    </div>

    <!-- customers.length > 1 OR a single row we deliberately did not auto-select
         because it is not the signed-in tenant — otherwise the user would see the
         mismatch notice with nothing to pick. -->
    <ng-container *ngIf="!isLoading && !errorMessage && (customers.length > 1 || noTenantMatch)">
      <div class="search-box" *ngIf="useSearch">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          type="text"
          [placeholder]="'CustomerSelectorSearchCustomers' | t"
          [(ngModel)]="searchTerm"
          autocomplete="off"
        />
      </div>

      <!-- Composite [value] `${CustomerId}|${TenantId}` — CustomerId alone is ambiguous
           across tenants; label disambiguates duplicates by tenant. -->
      <!-- An External ID user's rows are all their own (externalList): show them
           as an open list, so each one is visible without clicking the control. -->
      <select
        *ngIf="!useSearch"
        class="customer-select"
        [class.customer-list]="externalList"
        [attr.size]="externalList ? listSize : null"
        [(ngModel)]="selectedKey"
      >
        <option *ngFor="let c of customers" [value]="keyFor(c)">{{ labelFor(c) }}</option>
      </select>

      <div class="search-results" *ngIf="useSearch">
        <div
          class="search-result-item"
          *ngFor="let c of filteredCustomers"
          [class.selected]="selectedKey === keyFor(c)"
          (click)="selectedKey = keyFor(c)"
        >
          {{ labelFor(c) }}
        </div>
        <div class="no-results" *ngIf="filteredCustomers.length === 0">
          No customers match "{{ searchTerm }}"
        </div>
      </div>

      <button
        class="continue-btn"
        [disabled]="!selectedKey"
        (click)="onContinue()"
      >{{ 'CustomerSelectorContinue' | t }}</button>
    </ng-container>
  </div>
</div>
